import styled from 'styled-components';
import { spacing } from '@goeuro/app/client/frontend-components/src/style-values/spacing';
import mediaQueries from 'constants/mediaQueries';

type Size = 'sm' | 'md' | 'lg';

const getMaxWidth = (isTablet?: boolean) => ({
  fullWidth,
  size = 'lg',
}: {
  fullWidth?: boolean;
  size?: Size;
}) => {
  if (!fullWidth) {
    switch (size) {
      case 'md':
        return isTablet ? '832px' : '960px';
      case 'lg':
      default:
        return isTablet ? '832px' : '1168px';
    }
  }

  return 'none';
};

export const Container = styled.div<{
  fullWidth?: boolean;
  size?: Size;
  noPadding?: boolean;
}>`
  ${({ noPadding }) => (noPadding ? '' : `padding: 0 ${spacing.medium}px;`)}

  margin: 0 auto;
  position: relative;
  box-sizing: border-box;
  width: 100%;

  ${mediaQueries.tabletAndLarger} {
    max-width: ${getMaxWidth(true)};
  }

  ${mediaQueries.desktop} {
    max-width: ${getMaxWidth()};
  }
`;
